import React from 'react';

import { Grid, makeStyles } from '@gogame/components';
import { FormField } from '@gogame/form';
import { useDateFormat } from '@gogame/intl-ts';

const useStyles = makeStyles(() => ({
  box: {
    padding: '16px 16px 16px 0',
  },
}));

export const MonthAmount = ({ date, name, ...props }) => {
  const format = useDateFormat({ timeZone: 'utc', template: 'MONTH' });
  const styles = useStyles();

  return (
    <Grid item xs={2} className={styles.box}>
      <FormField.TextField
        type={'currency'}
        placeholder={'0'}
        name={name}
        label={format(date)}
        {...props}
        padding={'0'}
      />
    </Grid>
  );
};

export default MonthAmount;
